<template>
  <div class="temp-container full-width">
    <v-col class="stepper-main">
      <v-row class="px-12 ma-0">
        <v-col class="pa-0 ma-0">
          <h2>Vorschau der generierten Umfrage</h2>
          <p class="text-gray text-description mb-2">Hier ist Ihre generierte Umfrage. Überprüfen Sie die Fragen und speichern Sie die Umfrage.</p>
        </v-col>
      </v-row>
      <v-row class="mx-12 py-6 temp-content border-10">
        <v-col>
          <v-card flat class="border-10" style="height:fit-content;">
            <v-main class="mx-10 pa-0">
              <v-col class="ma-0 pa-0 pb-6 d-flex flex-row">
                <div class="header-box mr-2">
                  <v-icon color="gray">mdi-file-document</v-icon>
                </div>
                <div class="d-flex flex-column align-start justify-start">
                  <p class="font-xs text-gray-light ma-0">Umfragetitel</p>
                  <h4 class="text-gray text-right ma-0">{{ surveyDetails.title }}</h4>
                </div>
              </v-col>
              <PXSurvey :schema="schema" :displayMode="'display'"/>
            </v-main>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <div class="temp-bottom">
      <v-row class="px-12 py-4 ma-0 d-flex flex-row bg-white justify-space">
        <v-col class="pa-0 d-flex justify-start">
          <v-btn text @click.stop="prevStep" color="secondary"><v-icon>mdi-chevron-left</v-icon> Zurück</v-btn>
        </v-col>
        <v-col class="pa-0 d-flex justify-end">
          <v-btn elevation="0" @click="submitSurvey" color="primary">Umfrage generieren</v-btn>
        </v-col>
      </v-row>
    </div>
    <v-snackbar
        v-model="snackbar" timeout="3000" class="mb-12"
    >
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import PXSurvey from "@/components/common/PXSurvey.vue"
import surveyGenerator from '@/components/px-survey-generator'
import pxSurveyService from "@/pages/PxQuestionSurvey/PXSurveyPage/px-survey-service"
export default {
  props: [
      'surveyDetails',
      'pxQuestions',
      'schema',
      'selectedModule'
  ],
  data: () => ({
    surveyTitle: "",
    snackbar: false,
    snackbarText: 'Umfrage wurde erfolgreich erstellt',
  }),
  components: {
    PXSurvey
  },
  watch: {
  },
  mounted() {
    this.surveyTitle = this.surveyDetails.title;
    this.schema.title = this.surveyTitle;
    this.schema.deadlineDate = this.surveyDetails.deadlineDate;
  },
  methods: {
    submitSurvey(){
      this.snackbar = true;
      if(this.selectedModule == null) this.selectedModule = 0;
      pxSurveyService.savePXSurvey(this.schema, this.selectedModule).then(() => this.$router.push('/surveys'))
    },
    prevStep() {
      this.$emit('changeStep', 2);
    },
  },
};
</script>